<template>
    <v-dialog v-model="docView" fullscreen>
        <v-card>
            <v-toolbar color="secondary" dense dark>
                <v-spacer></v-spacer>
                <v-card-title primary-title>Document View</v-card-title>
                <v-spacer></v-spacer>
                <v-btn dark icon left @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-iterator :items="files" :page="page" :items-per-page="1" hide-default-footer>
                    <template v-slot:default="props">
                        <v-container v-for="(it, id) in props.items" :key="'document' + id"
                            style="background-color: #fff;" fluid>
                            <iframe :src="it.Link" style="width: 100%; height:70vh ;"></iframe>
                            <v-pagination v-model="page" :length="files.length" prev-icon="mdi-menu-left"
                                next-icon="mdi-menu-right"></v-pagination>
                            <v-row align="center" justify="space-around">
                                <v-btn text v-if="disabled"  @click="deleteFile(it,id)" color="error">
                                    <v-icon>mdi-delete-circle</v-icon> Delete File
                                </v-btn>
                                <v-btn @click="openUpdateModal(it)" text color="primary" class="mt-6">
                                    <v-icon>mdi-arrow-up-bold-box</v-icon> Update File
                                </v-btn>
                            </v-row>
                        </v-container>

                    </template>

                </v-data-iterator>
            </v-container>
        </v-card>

        <v-dialog v-model="dialog" max-width="460">
            <v-card>
                <v-container grid-list-xs>
                    <v-row>
                        <v-col>
                            <v-file-input v-model="file" dense hide-details label="Update File"
                                @change="UpdateFile()"></v-file-input>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <confirm-dialogue ref="confirmDialogue" style="z-index: 100;"></confirm-dialogue>
    </v-dialog>
</template>
<script>
import ConfirmDialogue from './../../Modals/ConfirmDialogue.vue';
import axios from "axios";
export default {
    props: ['keyUrl', 'docView'],
    components: {
        ConfirmDialogue
    },
    data: function () {
        return {
            Url: '',
            files: [],
            page: 1,
            file: null,
            dialog: false,
            disabled:false,
        }
        // 
    },
    methods: {
        viewDocuments: function () {
            this.$store.state.isLoading = true;
            axios
                .post('driver-list/view/document', this.keyUrl, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.files = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    logErr(error);
                })
        },
        openUpdateModal: function (itm) {
            this.item = itm;
            this.dialog = true;
        },
        async UpdateFile() {
            this.dialog = false;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Update File ' + this.item.Document,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                await this.update(this.item);
            }
        },
        
        async deleteFile(itm,id) {
            this.dialog = false;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Delete File ' + itm.Document,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                await this.delete(itm);
            }
        },
        
        delete: async function (itm,id) {
            var str = this.$store;
            str.state.isLoading = true;
            console.log(itm);
                try {
                    
                    const response = await axios.post('driver-list/delete/file/' + itm.LinkId, itm, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    this.files.splice(id,1);
                    itm.Link  = response.data;
                    str.state.isLoading = false;
                } catch (error) {
                    logErr(error);
                }
        },

        update: async function (itm) {
            var str = this.$store;
            str.state.isLoading = true;
            console.log(itm);
                try {
                    const formData = new FormData();
                    formData.append('file', this.file);
                    console.log(formData);

                    const response = await axios.post('driver-list/update/file/' + itm.LinkId, formData, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    itm.Link  = response.data;
                    str.state.isLoading = false;
                } catch (error) {
                    logErr(error);
                }
        },

    },
    mounted() {
        this.viewDocuments();
        if(this.$store.state.roles == 'CardingAgent' || this.$store.state.roles == 'Human Resources' || this.$store.state.roles == 'Administrator'){
            this.disabled =true;
        }
    },
}
</script>